import { Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import Home from "../pages/Home/Home";
import About from "../pages/About/About";
import Inquiry from "../pages/Inquiry/Inquiry";
import Work from "../pages/Work/Work";
import TattooAftercare from "../components/TattooAftercare/TattooAftercare";
import BookingPolicy from "../pages/BookingPolicy/BookingPolicy";
import ScrollToTop from "../components/ScrollToTop/ScrollToTop";
import useTitle from "../hooks/useTitle";

const AppRouter = () => {
  const location = useLocation();

  useTitle();

  const fadeVariant = {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
  };

  const routes = [
    { path: "/", element: <Home /> },
    { path: "/about", element: <About /> },
    { path: "/gallery", element: <Work /> },
    { path: "/inquiry", element: <Inquiry /> },
    { path: "/aftercare", element: <TattooAftercare /> },
    { path: "/booking-policy", element: <BookingPolicy /> }
  ];

  return (
    <AnimatePresence mode="wait">
      <ScrollToTop />
      <Routes location={location} key={location.pathname}>
        {routes.map(({ path, element }) => (
          <Route
            key={path}
            path={path}
            element={
              <motion.div
                variants={fadeVariant}
                initial="initial"
                animate="animate"
                exit="exit"
              >
                {element}
              </motion.div>
            }
          />
        ))}
      </Routes>
    </AnimatePresence>
  );
};

export default AppRouter;
